import { render, staticRenderFns } from "./showprofilemain.vue?vue&type=template&id=425d1622"
import script from "./showprofilemain.vue?vue&type=script&lang=js"
export * from "./showprofilemain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports